import styled from 'styled-components';

export const BoardContainer = styled.div`
  display: flex;
  flex: 1;
  padding: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 4px;
  }

gap: 8px; min-width: 0; overflow-x: auto;
`;
